import styled from 'styled-components';

export const TextAreaField = styled.textarea`
  height: 111px;
  margin: 0;
  padding: 15px 15px 62px;
  border: 1px solid ${({ theme }) => theme.backgroundColorButtonDisabled};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.backgroundBaseQuaternary};
  resize: none;
  :focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.primaryColor};
  }
`;
